<div class="container">
    <div class="row">
        <div class="col-lg-6 col-12">
            <img src="assets/img/drct-new.jpg" alt="Divine Retreat Centre" class="image">
        </div>
        <div class="col-lg-6 col-12">
            <h2>Divine Retreat Centre, Toronto (Canadian Vincentian Congregation Association)</h2>
            <h3>“For My House shall be called a House of Prayer for all Nations.”<span>(Isaiah 56:7)</span></h3>
            <span>Divine Retreat Centre, Toronto is one of the evangelization centres of the Vincentian 
                Congregation under the auspice of the Archdiocese of Toronto. At Divine Retreat Centre many 
                people from different walks of life and culture offer prayers and praise to God for His 
                powerful dwelling presence. Lets' pray to God that this retreat centre to become a house of 
                prayer for all nations.</span>
        </div>
    </div>
</div>